import { render, staticRenderFns } from "./InitioPanel.vue?vue&type=template&id=a248b844&scoped=true&"
import script from "./InitioPanel.vue?vue&type=script&lang=js&"
export * from "./InitioPanel.vue?vue&type=script&lang=js&"
import style0 from "./InitioPanel.vue?vue&type=style&index=0&id=a248b844&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a248b844",
  null
  
)

export default component.exports